import './NumberOfInvitesLeft.scss';

import Paragraph from 'components/TextComps/Paragraph';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

export const NumberOfInvitesLeft = observer(() => {
  const { t } = useTranslation();
  const iss = useStores().inviteStudentsStore;

  const renderNumberOfInvitesLeft = useCallback(() => {
    const invitesLeft = iss.numberOfInvitesLeft - iss.newInvites.length;
    const className = invitesLeft < 0 ? 'exceeded' : '';

    return <span className={className}>{invitesLeft}</span>;
  }, [iss.newInvites.length, iss.numberOfInvitesLeft]);

  return (
    <div className='number-of-invites-left'>
      <Paragraph>
        <strong>
          {`${t('NumberOfInvitesLeft', { ns: 'studentsPage' })} `} {renderNumberOfInvitesLeft()}
        </strong>
      </Paragraph>
    </div>
  );
});

export default NumberOfInvitesLeft;
